import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { CrmService } from '../../services/crm/crm.service';
import { CmsService } from '../../services/cms/cms.service';
import { FormsUtils } from 'src/app/utils/FormsUtils';
import { AppConfigService } from 'src/app/services/app-config.service';
import { PublicUtils } from 'src/app/utils/PublicUtils';
import { DataLayer } from 'src/app/utils/dataLayer';
import { CampaignMonitor } from 'src/app/utils/CampaignMonitor';
import swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
  
  public myGroup: FormGroup;
  public formsUtils = new FormsUtils();
  ready:boolean = false;
  public showPrograms:boolean = true;
  public muestraProgramas:boolean = false;
  publicUtils = new PublicUtils();
  dataLayerUtils = new DataLayer();
  content:any;
  programSena:any;
  faculties:any;
  types:any;
  path;
  public nameProgram;
  public nameUser;

  constructor(private formBuilder: FormBuilder,
  public appConfig:AppConfigService,
  private crm:CrmService,
  private cms:CmsService) { }
  CampaignMonitor = new CampaignMonitor();
  dataForm:any = {
    types:[],
    sites:[],
    programs:[],
    typesDoc:[],
    deptos:[],
    patterNumDoc:"",
  }
  valueForm:any = {
    typeDoc:"",
    campaings:{}
  }
  ngOnInit() {
    this.path = this.appConfig.config["sever"]+this.appConfig.config["path"];
    this.CampaignMonitor.init('cmpid', 'ANDINACK');
    this.getContent();
    this.getDataForm();
  }

  buildForm(){
    let obj = {};
    for(let i = 0; i < this.appConfig.landing["_value"].filters.length; i++){
      obj[this.appConfig.landing["_value"].filters[i].filter] = ['', Validators.required];
    }

    obj["name"] = ['', Validators.required];
    obj["lastName"] = ['', Validators.required];
    obj["tipoDoc"] = ['', Validators.required];
    obj["numDoc"] = ['', Validators.required];
    obj["email"] = ['', [Validators.required, Validators.email]];
    obj["celphone"] = ['', Validators.required];
    obj["state"] = ['', Validators.required];
    obj["city"] = ['', Validators.required];
    obj["terms"] = ['', Validators.required];
    obj["programTypeSena"] = ['', Validators.required];
    obj["programSena"] = ['', Validators.required];
    obj["dontDisturb"] = [false];


    if(this.appConfig.landing["_value"]["tipo_oportunidad"] == "POS"){
      obj["titulo"] = ['prof', ''];
    } 
    this.myGroup = this.formBuilder.group(obj);
  }

  getDataForm(){
    this.crm.getDocumentTypes().subscribe(rps => {
      this.dataForm.typesDoc = rps["documentTypes"];
      this.crm.getStates().subscribe(rps => {
        this.dataForm.deptos = rps["states"];
        this.valueForm.campaings = this.CampaignMonitor.getCampaignsValues();
        this.loadRex("CC");
      }, err => {});
    },err => {});
    let filters = this.publicUtils.orderFilters(this.appConfig.landing["_value"].configForm);
    if(filters[0].filter == "program"){
      filters[0].items = this.appConfig.programs["_value"];
    }else{
      filters[0].items = this.formsUtils.orderBy(this.appConfig.programs["_value"],filters[0].filter);
    }
    this.appConfig.landing["_value"].filters = filters;
    this.buildForm();
  }

  getContent(){
    this.cms.getContents().subscribe( rps => {
      this.content = this.publicUtils.orderData(rps["data"][0].data);
      setTimeout(function(){window["init"]();},2000)
      this.crm.getPrograms("FUAA").subscribe(data => {
        let programs = this.publicUtils.orderPrograms(rps["data"][1].data,data["programs"]);
        let programSena = this.publicUtils.orderProgramsSena(rps["data"][2].data,data["programs"],programs);
        this.appConfig.programs.next(programs); 
        this.appConfig.programSena.next(programSena);
        //this.types = this.publicUtils.orderTypes(programs);
        this.types = this.formsUtils.orderBy(programSena,"nameSena");
        this.faculties = this.publicUtils.orderFaculty(programs);
        if(this.publicUtils.getURLParam("utm_code") != null){
          this.loadContentProgram(this.publicUtils.getURLParam("utm_code"));
        }
        this.ready = true;
      },err => {
        console.log(err);
      });
    },
    err => {
      //swal.fire('Hey user!', err, 'error');
    });
  }

  loaditems($event, $data){    
    if($data != undefined && $event != ""){
      let item = JSON.parse($event);
      if($data.filter == "program"){
        this.appConfig.landing["_value"].filters[$data.position].items = item.programs;
      }else{
        this.appConfig.landing["_value"].filters[$data.position].items = this.formsUtils.orderBy(item.programs,$data.filter);
      }
      setTimeout(function(){
        try{ document.getElementById($data.filter)["selectedIndex"] = 0;}catch(e){}finally{}
      },50);     
      this.myGroup.controls[$data.filter].setValue('');
    }

  }

  loadRex($event){
    let code = $event;
    if(typeof $event == "object"){
      code = $event.srcElement.value;
    }
    let docs = this.dataForm.typesDoc;
    for(let i = 0; i < docs.length; i++){
      if(docs[i].code == code){
        this.valueForm.typeDoc = docs[i].code;
        this.dataForm.patterNumDoc = this.formsUtils.getPattern(docs[i].allowedChars.toUpperCase()).code;
      }
    }
  }

  mostrarProgramas($event){
    this.showPrograms = !this.showPrograms;
    if (this.showPrograms){
      $("#content").removeClass();
        $("#content").addClass("first-action");
        $(".radio-toolbar input").prop("checked", false);
      this.resetForm()
      setTimeout(function(){window["init"]();},2000);
    }else{
      let progSena = this.appConfig.programSena['_value'];
      let centinela = false;
      for(let i = 0; i < progSena.length && centinela == false; i++){
        if ($event == progSena[i].codeSena){
          this.dataForm.programasAndina = progSena[i].programs;
          this.dataForm.cantProg= this.dataForm.programasAndina.length;
          centinela = true;
        }
      }
      setTimeout(function(){window["init"]();},2000);
      $("#content").removeClass();
        $("#content").addClass("fourth-action");
    }
  }

  cambiaBoton($prog){
        
      this.myGroup.patchValue({programSena:''});
        $("#content").removeClass();
        $("#content").addClass("second-action");
        this.appConfig.cantTypes = $prog.charAt(0).toUpperCase() + $prog.toLowerCase().slice(1);
        
  }
  envioPrograma($prog){
    this.nameProgram = $prog.name;
    
  }
  loadCities(){
    this.crm.getCities(JSON.parse(this.myGroup.controls.state.value).stateCode).subscribe(rps => {
      this.dataForm.cities = rps["cities"];
    }, err => {

    })
  }

  sendInfo(){    
    if(this.myGroup.valid){
      let nombreTitulo = this.appConfig.cantTypes;
        this.sendLead(nombreTitulo);
       
    }else{      
      swal.fire('', this.formsUtils.loadMessage(this.myGroup.controls), 'error');
    }
  }

  sendPotencial(nombreTitulo){
    let data = this.myGroup.controls;
    let program = JSON.parse(data.program.value);
    let depto = JSON.parse(data.state.value).label;
    let ciudad = JSON.parse(data.city.value).label;
    
    
    this.crm.sendPotencial(
      'N/A',                                          /*$CSUAgent*/
      'N/A',                                          /*$agentName*/
      'N/A',                                          /*$agentDocument*/
      'N/A',                                          /*$agentMail*/
      'N/A',                                          /*$exploraName*/
      'N/A',                                          /*$exploraDocument*/
      'N/A',                                          /*$exploraMail*/
      this.appConfig.landing["_value"]["origen"],     /*$strategy*/
      data.name.value,                                /*$userName*/
      data.lastName.value,                            /*$userLastName*/
      this.valueForm.typeDoc,                         /*$userDocumentType*/
      data.numDoc.value,                              /*$userDocumentNumber*/
      JSON.parse(data.state.value).value,             /*$state*/
      JSON.parse(data.city.value).value,              /*$city*/
      'N/A',                                          /*$schoolName*/
      'N/A',                                          /*$userLastGrade*/
      data.email.value,                               /*$userEmail*/
      '57'+data.celphone.value.toString(),            /*$userMobilePhone*/
      'N/A',                                          /*$userPhone*/
      'N/A',                                          /*$userGenre*/
      program.programType,                            /*$programType*/
      program.modality,                               /*$modality*/
      program.site,                                   /*$site*/
      program.code,                                   /*$firstInterestProgram*/
      'N/A',                                          /*$secondInterestProgram*/
      'N/A',                                          /*$interestPeriod*/
      '1',                                            /*$habeasData*/
      'N/A',                                          /*$address*/
      'N/A',                                          /*$neightborhood*/
      'N/A',                                          /*$province-probable campo duplicado*/
      'N/A',                                          /*$linkedin*/
      'N/A',                                          /*$firstAttendantName*/
      'N/A',                                          /*$firstAttendantMail*/
      'N/A',                                          /*$firstAttendantPhone*/
      'N/A',                                          /*$secondAttendantName*/
      'N/A',                                          /*$secondAttendantMail*/
      'N/A',                                          /*$secondAttendantPhone*/
      'N/A',                                          /*$keyPoint*/
      program.loadCode,                               /*$loadPresence*/
      program.campaign,                               /*$servicePresence*/
      this.publicUtils.getFormatedDate(),             /*$acceptanceDate*/
      'N/A',                                          /*$twitter*/
      'N/A',                                          /*$facebook*/
      'CO',                                           /*$countryCode*/
      'N/A',                                          /*$activityOrigin*/
      'N/A',                                          /*$firstInterestArea*/
      'N/A',                                          /*$secondInterestArea*/
      'FUAA',                                         /*$universityCode*/
      'N/A',                                          /*$universityChosen*/
      'N/A',                                          /*$originalIndexRow*/
      'N/A',                                          /*$universityMedium*/
      'N/A',                                          /*$agreement*/
      'N/A',                                          /*$company*/
      'N/A',                                          /*$digitalLabDetails*/
      'N/A',                                          /*$GUID*/
      'EXTERNAL POTENCIAL',                           /*$registerType*/
      'N/A',                                          /*$contactFormMail*/
      'N/A',                                          /*$contactFormPhone*/
      'N/A',                                          /*$contactFormFax*/
      program.campaign,                               /*$campaignCode*/
      'N/A',                                          /*$opportunityType*/
      'N/A',                                          /*$siteLabel*/
      'N/A',                                          /*$academicLevel*/
      program.journeyCode,                            /*$journey*/
      program.journeyCode,                            /*$journey2*/
      'N/A',                                          /*$interestLevel*/
      'N/A',                                          /*$agreementType*/
      this.valueForm.campaings,
      this.appConfig.landing["_value"]["landing_name"],
      data.dontDisturb.value
      ).subscribe(rps =>{
        //swal.fire('', 'Registro exitoso, muy pronto te contactaremos', 'success');
        this.loadDatalayer(program, rps, depto, ciudad, nombreTitulo);
      },err =>{
        //swal.fire('Upss!!', 'ocurrio un error,  por favor intenta mas tarde', 'error');
      });
  }

  sendLead(nombreTitulo){
    let data = this.myGroup.controls;
    this.nameUser = data.name.value;
    let program = JSON.parse(data.program.value);
    let depto = JSON.parse(data.state.value).label;
    let ciudad = JSON.parse(data.city.value).label;
    

    this.crm.sendLead(
      'N/A',                                          /*$CSUAgent*/
      'N/A',                                          /*$agentName*/
      'N/A',                                          /*$agentDocument*/
      'N/A',                                          /*$agentMail*/
      'N/A',                                          /*$exploraName*/
      'N/A',                                          /*$exploraDocument*/
      'N/A',                                          /*$exploraMail*/
      this.appConfig.landing["_value"]["origen"],     /*$strategy*/
      data.name.value,                                /*$userName*/
      data.lastName.value,                            /*$userLastName*/
      this.valueForm.typeDoc,                         /*$userDocumentType*/
      data.numDoc.value,                              /*$userDocumentNumber*/
      JSON.parse(data.state.value).value,             /*$state*/
      JSON.parse(data.city.value).value,              /*$city*/
      'N/A',                                          /*$schoolName*/
      'N/A',                                          /*$userLastGrade*/
      data.email.value,                               /*$userEmail*/
      '57'+data.celphone.value.toString(),            /*$userMobilePhone*/
      'N/A',                                          /*$userPhone*/
      'N/A',                                          /*$userGenre*/
      program.programType,                            /*$programType*/
      program.modality,                               /*$modality*/
      program.site,                                   /*$site*/
      program.code,                                   /*$firstInterestProgram*/
      'N/A',                                          /*$secondInterestProgram*/
      'N/A',                                          /*$interestPeriod*/
      '1',                                            /*$habeasData*/
      'N/A',                                          /*$address*/
      'N/A',                                          /*$neightborhood*/
      'N/A',                                          /*$province-probable campo duplicado*/
      'N/A',                                          /*$linkedin*/
      'N/A',                                          /*$firstAttendantName*/
      'N/A',                                          /*$firstAttendantMail*/
      'N/A',                                          /*$firstAttendantPhone*/
      'N/A',                                          /*$secondAttendantName*/
      'N/A',                                          /*$secondAttendantMail*/
      'N/A',                                          /*$secondAttendantPhone*/
      'N/A',                                          /*$keyPoint*/
      program.loadCode,                               /*$loadPresence*/
      program.campaign,                               /*$servicePresence*/
      this.publicUtils.getFormatedDate(),             /*$acceptanceDate*/
      'N/A',                                          /*$twitter*/
      'N/A',                                          /*$facebook*/
      'CO',                                           /*$countryCode*/
      'N/A',                                          /*$activityOrigin*/
      'N/A',                                          /*$firstInterestArea*/
      'N/A',                                          /*$secondInterestArea*/
      'FUAA',                                         /*$universityCode*/
      'N/A',                                          /*$universityChosen*/
      'N/A',                                          /*$originalIndexRow*/
      'N/A',                                          /*$universityMedium*/
      'N/A',                                          /*$agreement*/
      'N/A',                                          /*$company*/
      'N/A',                                          /*$digitalLabDetails*/
      'N/A',                                          /*$GUID*/
      'EXTERNAL LEAD',                                /*$registerType*/
      'N/A',                                          /*$contactFormMail*/
      'N/A',                                          /*$contactFormPhone*/
      'N/A',                                          /*$contactFormFax*/
      program.campaign,                               /*$campaignCode*/
      program.oppType,                                /*$opportunityType*/
      'N/A',                                          /*$siteLabel*/
      program.journeyCode,                            /*$journey*/
      'N/A',                                          /*$academicLevel*/
      this.valueForm.campaings,
      this.appConfig.landing["_value"]["landing_name"],
      data.dontDisturb.value
      ).subscribe(rps =>{
        //swal.fire('', 'Registro exitoso, muy pronto te contactaremos', 'success');
        this.loadDatalayer(program, rps, depto, ciudad, nombreTitulo);
        $("#content").removeClass();
        $("#content").addClass("fifth-action");
        $(".overlay").hide();
      },err =>{
        //swal.fire('Upss!!', 'ocurrio un error,  por favor intenta mas tarde', 'error');
      });
  }

  resetForm(){
    let obj = {};
    if(this.appConfig.landing["tipo_oportunidad"] == "PRE"){
      obj["typeProgram"] = ['', Validators.required];
    } 
    obj["program"] = ['', Validators.required];
    obj["name"] = ['', Validators.required];
    obj["lastName"] = ['', Validators.required];
    obj["tipoDoc"] = ['', Validators.required];
    obj["numDoc"] = ['', Validators.required];
    obj["email"] = ['', [Validators.required, Validators.email]];
    obj["celphone"] = ['', Validators.required];
    obj["state"] = ['', Validators.required];
    obj["city"] = ['', Validators.required];
    obj["terms"] = ['', Validators.required];
    obj["programTypeSena"] = ['', Validators.required];
    obj["programSena"] = ['', Validators.required];

    if(this.appConfig.landing["tipo_oportunidad"] == "POS"){
      obj["titulo"] = ['prof', ''];
    } 
    this.myGroup = this.formBuilder.group(obj);
    //document.getElementById("tipo-doc")["value"] = "";
  }

  loadDatalayer(program, rps, depto, ciudad, nombreTitulo){
    let oportTransform = this.dataLayerUtils.orderOportunidad(program);
    let modalidadTransform = this.dataLayerUtils.orderModalidad(program)
    let tipoTransform = this.dataLayerUtils.orderTipo(program);
    let programaCorto = this.dataLayerUtils.orderProgCor(program.code);
    let tipoDoc = this.dataLayerUtils.orderDoc(this.valueForm.typeDoc);
    let guid = "";
    let fechaenvio = "";
    let sede = this.myGroup.controls.site != undefined ? JSON.parse(this.myGroup.controls.site.value).name : modalidadTransform.value == 'Virt' ? 'Virtual':'N/A';

    if(rps["WSDLResult"].srvRegistroCallBackResult == undefined){
      guid = rps["WSDLResult"].srvRegistroPotencialResult.strGUID;
      fechaenvio = rps["data_sended"].objRequestWCB.FECHAACEPTACION;
    }else{
      guid = rps["WSDLResult"].srvRegistroCallBackResult.strGUID;
      fechaenvio = rps["data_sended"].objRequestWCB.TEMPORALIDAD;
    }

    window["dataLayer"].push({
      'event': 'DATA_SEND',
      'guid':guid,
      'formulario':"LP",
      'oportunidad':oportTransform.value,
      'tipo':tipoTransform.value,
      'modalidad':modalidadTransform.value,
      'programa':programaCorto.value,
      'sede': sede,
      'departamento': depto,
      'ciudad':ciudad,
      'documento':tipoDoc.value,
      'titulo' : nombreTitulo,
      'fechaPI':fechaenvio            
    });
    this.resetForm();
  }
  
  loadContentProgram($data){ 
    if(typeof $data != "object"){
      let progs = this.appConfig.programs["_value"];
      let centinela = false;
      for(let i =0; i < progs.length && centinela == false; i++){
        if($data == progs[i].code){
          centinela = true;
          if(progs[i].Imagen_BANNER != "N/A" && progs[i].Imagen_BANNER != ""){
            this.content.BANNER.Imagen = progs[i].Imagen_BANNER;
          }
        }
      }
    }
  }
}
